<template lang="pug">
  .c-bananas-widget(v-if='tourLists' v-scroll="scrollVisible")
    .c-bananas-widget__loop(v-for='(tourList, index) in tourLists')
      .c-offercard__wrapper(v-for='(offer, index) in tourList.tours' :class="['js-bn-tour-offercard--' + index]")
        .c-offercard
          .c-offercard__image(:style="{backgroundImage: 'url('+ offer.teaser_picture +')'}")
          .c-offercard__tour-besteseller(v-if="offer.bestseller") {{ $t("text.tour.bestseller") }}
          .c-offercard__info
            .c-offercard__price
              img.c-offercard__provider-image(src="https://s3.eu-central-1.amazonaws.com/com.holidaypirates.assets/img/partner/tours/getyourguide_H25.png")
              span.c-offercard__price-prefix {{ $t('text.pricefrom') }}
              span.c-offercard__price-currency(v-if="offer.currency !== 'EUR'") {{$t('text.currency.' + offer.currency)}}
              span.c-offercard__price-value {{ offer.price | formatPrice }}
              span.c-offercard__price-currency(v-if="offer.currency === 'EUR'") {{$t('text.currency.' + offer.currency)}}
            .c-offercard__category
              img.c-offercard__category-icon(src='https://s3.eu-central-1.amazonaws.com/com.holidaypirates.assets/icons/tours.svg')
              .c-offercard__headline {{ offer.title }}
            .c-offercard__location {{ offer.category_name }}
            p.c-offercard__tour-description {{ offer.abstract | formatDescription }}
          .c-offercard__tour-extras
            .c-offercard__tour-details
              .c-offercard__tour-detail.c-offercard__tour-duration {{ offer.duration }}
              .c-offercard__tour-detail.c-offercard__tour-certificated(v-if="offer.certified") {{ $t("text.tour.certified") }}
            .c-offercard__tour-rating(v-if="offer.overall_rating")
              .c-offercard__tour-rating-wording(:data-qa-rating="offer.overall_rating") {{ offer.overall_rating }} / 5
              .c-offercard__tour-rating-count {{ offer.number_of_ratings }} {{ $t("text.reviews") }}
          .c-offercard__button
            form(action="https://rdr.holidaypirates.group/v1/link" target="_blank" method="post")
              input(type="hidden" name="config[redirect]" value="true")
              input(type="hidden" name="data[url][encoding]" value="base64_url")
              input(type="hidden" name="data[url][url]" :value="base64EncodeUnicode(offer.url)")
              input.c-btn.c-btn--function.c-offercard__button-link(:value='$t("button.tour")' type="submit" @click='clickOut')
</template>

<script>
import fecha from 'fecha'
import dbActions from '../api/dbactions'

export default {
  name: 'TourTeaser',
  props: ['tourLists', 'dateFormat', 'timeFormat'],
  data() {
    return {
      localMessages: this.$store.getters.getLocaleMessages,
      tracked: false,
      trackHostNames: this.$store.getters.getTrackingHostNames,
      trackingAllowed: true
    }
  },
  mounted() {
    this.scrollVisible()
  },
  filters: {
    formatDate(rawDate) {
      return fecha.format(new Date(rawDate), 'DD.MM.YYYY')
    },
    formatDescription(description) {
      if (description.length > 150) {
        return description.substring(0, 150) + ' ...'
      } else {
        return description
      }
    },
    formatPrice(price) {
      return Math.ceil(price)
    },
    filterRatingMax(maxRatingValue) {
      return maxRatingValue / 10
    }
  },
  methods: {
    clickOut() {
      // Track clickOut
      let actionData = {
        url: window.location.href,
        language: this.$store.getters.getLocale,
        type: 'clickOut',
        vertical: 'tour',
        unique: this.$store.getters.getUniqueClickOut
      }
      this.$store.dispatch('updateUniqueClickOut')
      if (this.$store.getters.getTrackingIsAllowed) {
        dbActions.trackAction(actionData, this)
      }
      this.trackClick()
    },
    checkTrackingAllowed() {
      // Test Cookie with tracking rules
      // this.$cookies.set('tarteaucitron', '!snowplow=false!doubleclick=true!hotjar=true!googletagmanager=true!trustpilot=true!facebook=true!instagram=true!pinterest=true!twitter=true!youtube=true')
      if (this.$cookies.isKey('tarteaucitron')) {
        let trackingAllowed = this.$cookies.get('tarteaucitron')
        trackingAllowed = trackingAllowed.split('!')
        trackingAllowed = trackingAllowed[1].split('=')
        if (trackingAllowed[1] !== 'true') {
          this.trackingAllowed = false
          // Set store flag to false for tracking is allowed
          this.$store.dispatch('updateTrackingIsAllowed')
        } else {
          if (!this.trackHostNames.includes(window.location.hostname)) {
            this.trackingAllowed = false
            // Set store flag to false for tracking is allowed
            this.$store.dispatch('updateTrackingIsAllowed')
          }
        }
      }
      // Everytime true on localhost for development
      if (window.location.hostname === 'localhost') {
        this.trackingAllowed = false
        this.$store.dispatch('updateTrackingIsAllowed')
        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.toString() !== '') {
          if (urlParams.has('bn-track')) {
            if (urlParams.get('bn-track') === '1') {
              this.trackingAllowed = true
              this.$store.dispatch('setTrackingIsAllowed')
            }
          }
        }
      }
    },
    scrollVisible() {
      if (this.trackingAllowed && !this.tracked) {
        this.checkOfferVisible()
      }
    },
    getBoundingClientRect(element) {
      const {
        top,
        right,
        bottom,
        left,
        width,
        height,
        x,
        y
      } = element.getBoundingClientRect()
      return { top, right, bottom, left, width, height, x, y }
    },
    checkOfferVisible() {
      const pageCoordinates = this.getBoundingClientRect(this.$el.children[0])
      if (
        pageCoordinates.top >= 0 &&
        pageCoordinates.left >= 0 &&
        pageCoordinates.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        pageCoordinates.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      ) {
        let pageType = 'undefined'
        let pagePostId = 'undefined'
        if (window.dataLayer.length > 0) {
          if (window.dataLayer[0].hasOwnProperty('pageType')) {
            pageType = window.dataLayer[0].pageType
          }
          if (window.dataLayer[0].hasOwnProperty('pagePostId')) {
            pagePostId = window.dataLayer[0].pagePostId
          }
        }
        try {
          const offer = this.tourLists.data
          const offerId = offer.ranks[0].items[0]
          window.dataLayer.push({
            event: 'promoView',
            category: 'dealPromotion',
            action: 'impression',
            label:
              'automated' +
              '|' +
              pagePostId +
              '|' +
              'GetYourGuide' +
              '|tour|' +
              offerId, // for example 'unifiedSearch|flight'
            value: undefined,
            ecommerce: {
              promoView: {
                promotions: [
                  {
                    id: offerId,
                    name:
                      'automated|' +
                      'GetYourGuide' +
                      '|' +
                      pageType +
                      '|tours|' +
                      offer.properties[offerId].name, // for example 'unifiedSearch|flight'
                    creative:
                      offer.properties[offerId].location.continent +
                      ':' +
                      offer.properties[offerId].location.country +
                      ':' +
                      offer.properties[offerId].location.city,
                    position: undefined
                  }
                ]
              }
            }
          })
        } catch (err) {}
        this.tracked = true
      }
    },
    base64EncodeUnicode(str) {
      // First we escape the string using encodeURIComponent to get the UTF-8 encoding of the characters,
      // then we convert the percent encodings into raw bytes, and finally feed it to btoa() function.
      const utf8Bytes = encodeURIComponent(str).replace(
        /%([0-9A-F]{2})/g,
        function(match, p1) {
          return String.fromCharCode('0x' + p1)
        }
      )

      return btoa(utf8Bytes)
    },
    trackClick() {
      window.dataLayer = window.dataLayer || []
      let pageType = 'undefined'
      let pagePostId = 'undefined'
      if (window.dataLayer.length > 0) {
        if (window.dataLayer[0].hasOwnProperty('pageType')) {
          pageType = window.dataLayer[0].pageType
        }
        if (window.dataLayer[0].hasOwnProperty('pagePostId')) {
          pagePostId = window.dataLayer[0].pagePostId
        }
      }
      try {
        const offer = this.tourLists[0].data
        const offerId = offer.ranks[0].items[0]
        window.dataLayer.push({
          event: 'promoClick',
          category: 'dealPromotion',
          action: 'conversion',
          label:
            'automated' +
            '|' +
            pagePostId +
            '|' +
            'GetYourGuide' +
            '|tour|' +
            offerId, // for example 'unifiedSearch|flight'
          value: undefined,
          ecommerce: {
            promoClick: {
              promotions: [
                {
                  id: offerId,
                  name:
                    'automated|' +
                    'GetYourGuide' +
                    '|' +
                    pageType +
                    '|tour|' +
                    offer.properties[offerId].name,
                  position: undefined
                }
              ]
            }
          }
        })
      } catch (err) {}
      this.tracked = true
    }
  }
}
</script>
